var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { getPluginRegistry } from "./Helpers";
var hasOwnProperty = Object.prototype.hasOwnProperty;
function is(x, y) {
    // SameValue algorithm
    if (x === y) { // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        // Added the nonzero y check to make Flow happy, but it is redundant
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
}
export function shallowEqual(objA, objB) {
    if (is(objA, objB)) {
        return true;
    }
    if (typeof objA !== 'object' || objA === null ||
        typeof objB !== 'object' || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    // Test for A's keys different from B.
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) ||
            !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}
export var stateConnected = function (cmp) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _a, _b, _c, _d;
            var _this = _super.apply(this, arguments) || this;
            _this.lastState = {
                state: (_b = (_a = getPluginRegistry()) === null || _a === void 0 ? void 0 : _a.store.getState()) !== null && _b !== void 0 ? _b : {},
                dispatch: (_d = (_c = getPluginRegistry()) === null || _c === void 0 ? void 0 : _c.store.dispatch) !== null && _d !== void 0 ? _d : (function (p) { return p; }),
            };
            _this.update = function (value) {
                //                console.log("check ? state in update => ", value);
                setTimeout(function () {
                    //                    console.log("state in update => ", value);
                    if (!shallowEqual(_this.lastState.state, value.state)) {
                        _this.lastState = value;
                        _this.forceUpdate();
                    }
                    ;
                }, 0);
            };
            return _this;
        }
        class_1.prototype.componentDidMount = function () {
            var _a, _b;
            (_b = (_a = getPluginRegistry()) === null || _a === void 0 ? void 0 : _a.stateEventHandler) === null || _b === void 0 ? void 0 : _b.on(this.update);
        };
        class_1.prototype.componentWillUnmount = function () {
            var _a, _b;
            (_b = (_a = getPluginRegistry()) === null || _a === void 0 ? void 0 : _a.stateEventHandler) === null || _b === void 0 ? void 0 : _b.off(this.update);
        };
        class_1.prototype.render = function () {
            var _a, _b;
            this.lastState.state = (_b = (_a = getPluginRegistry()) === null || _a === void 0 ? void 0 : _a.store.getState()) !== null && _b !== void 0 ? _b : {};
            var C = cmp;
            var props = __assign(__assign({}, this.props), this.lastState);
            return React.createElement(C, __assign({}, props));
        };
        return class_1;
    }(React.Component));
};
